<template>
  <div class="decision-engine d-flex flex-column align-items-center">
    <div class="decision-engine-wrapper d-flex justify-content-center w-100">
      <div v-if="isOrgAdmin" class="decision-engine-page">
        <router-view @hide-tooltips="hideTooltips()" />
      </div>
      <empty-page v-else type="permission"></empty-page>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { closeAllTooltips } from '@inscribe/signal';
import EmptyPage from '@/shared/components/EmptyPage.vue';

export default {
  components: { EmptyPage },
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
  },
  watch: {
    '$route.hash': function () {
      if (this.$route.hash) {
        this.scrollToSection(this.$route.hash);
      } else {
        document.querySelector('.app-wrapper').scrollTo(0, 0);
      }
    },
  },
  mounted() {
    if (this.isOrgAdmin) {
      this.getConfigRulesSchema();
    }
  },
  methods: {
    ...mapActions({
      getConfigRulesSchema: 'getConfigRulesSchema',
    }),
    scrollToSection(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    },
    hideTooltips() {
      closeAllTooltips();
    },
  },
};
</script>

<style lang="scss" scoped>
.decision-engine {
  min-height: 100%;

  .decision-engine-wrapper {
    min-height: 100%;
  }

  :deep(.decision-engine-page-content) {
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 32px;
    padding-bottom: 32px;
    margin: 0 auto;
    width: 1200px;
  }

  &-view,
  &-heading,
  &-page,
  &-menu {
    width: 100%;

    .more-link {
      display: none;
    }

    @include respond-to('large') {
      width: 100%;
      min-width: auto !important;

      .responsive-hide {
        display: none !important;
      }

      .more-link {
        display: list-item;
      }
    }

    :deep(.items-list) {
      $border-radius: 24px;

      border: 1px solid $light-neutral-60;

      .decision-engine-card {
        border-bottom: 1px solid $light-neutral-60;
        width: 100%;
      }

      .decision-engine-card:last-of-type {
        border-bottom: 0;
        border-bottom-left-radius: $border-radius;
        border-bottom-right-radius: $border-radius;
      }

      .decision-engine-card:first-of-type {
        border-top-left-radius: $border-radius;
        border-top-right-radius: $border-radius;
      }
    }
  }
}
</style>
